import React from "react";
import { Routes, Route } from "react-router-dom";

import PermissionRoute from "./components/auth/PermissionRoute.js";

import Login from "./page/login.js";
import Portal from "./page/portal.js";
import Console from "./page/console.js";
import PolicyPrivacy from "./page/policy_privacy.js";

import Template from "./page/template.js";

// Mobile
import Mobile from "./page/mobile/mobile.js";

// SUPER USER
import CompanyManagement from "./page/super-user/companies.js";

// ADMIN
import AdminAssetReport from "./page/admin/asset-report.js";
import AdminAssets from "./page/admin/assets.js";
import AdminAuditLogs from "./page/admin/audit-logs.js";
import AdminSettings from "./page/admin/settings.js";
import AdminCostReport from "./page/admin/cost-report.js";
import AdminCustomers from "./page/admin/customers.js";
import AdminDashboard from "./page/admin/dashboard.js";
import AdminInspectionPlan from "./page/admin/inspection-plan.js";
import AdminPmCompliance from "./page/admin/pm-compliance.js";
import AdminPmDashboard from "./page/admin/pm-dashboard.js";
import AdminChecklistTemplates from "./page/admin/checklist-templates.js";
import AdminRoles from "./page/admin/roles.js";
import AdminScheduling from "./page/admin/scheduling.js";
import AdminSalesVisitPlanning from "./page/admin/sales-visit-planning.js";
import AdminObjectives from "./page/admin/objectives.js";
import AdminTechnicians from "./page/admin/technicians.js";
import AdminUsers from "./page/admin/users.js";
import AdminDepartments from "./page/admin/departments.js";
import AdminSections from "./page/admin/sections.js";
import AdminPositions from "./page/admin/positions.js";
import AdminProjects from "./page/admin/projects.js";
import AdminSale from "./page/admin/sale.js";
// ปิดหน้า finance ไว้ก่อน (ยังไม่ได้ใช้งาน) - ดูเมนูที่ปิดไว้ใน components/global.js
// import AdminFinance from "./page/admin/finance.js";
import AdminWorkOrderSummary from "./page/admin/work-order-summary.js";
import AdminWorkOrders from "./page/admin/work-orders.js";
import AdminWorkRequests from "./page/admin/work-requests.js";
import AdminWorkrequestConfigWireframe from "./page/admin/workrequest-config-wireframe.js";
import AdminServiceBomConfig from "./page/admin/service-bom-config.js";
import AdminCustomerWarrantyConditions from "./page/admin/customer-warranty-conditions.js";
import AdminCompanyVehicles from "./page/admin/company-vehicles.js";
import AdminRootCauses from "./page/admin/root-causes.js";
import AdminCompanyHolidays from "./page/admin/company-holidays.js";
import AdminTechnicianLeaves from "./page/admin/technician-leaves.js";

// CUSTOMER
import CustomerAppointments from "./page/customer/appointments.js";
import CustomerAssetReport from "./page/customer/asset-report.js";
import CustomerAssets from "./page/customer/assets.js";
import CustomerCostReport from "./page/customer/cost-report.js";
import CustomerDashboard from "./page/customer/dashboard.js";
import CustomerServiceHistory from "./page/customer/service-history.js";
import CustomerServiceSummary from "./page/customer/service-summary.js";
import CustomerSlaReport from "./page/customer/sla-report.js";
import CustomerWorkRequests from "./page/customer/work-requests.js";

// WAREHOUSE
import WarehouseDashboard from "./page/warehouse/dashboard.js";
// ปิดเมนู Asset (บันทึกรับประกัน Vendor) ไว้ก่อน — ดู components/global.js
// import WarehouseAssets from "./page/warehouse/assets.js";
import WarehouseStock from "./page/warehouse/stock.js";
import WarehouseTechnicianStock from "./page/warehouse/technician-stock.js";
import WarehousePartsWithdraw from "./page/warehouse/parts-withdraw.js";
import WarehousePartsReturn from "./page/warehouse/parts-return.js";
import WarehousePrPo from "./page/warehouse/pr-po.js";
import WarehouseGoodsReceipt from "./page/warehouse/goods-receipt.js";
import WarehouseGoodsIssue from "./page/warehouse/goods-issue.js";
import WarehouseStockClaim from "./page/warehouse/stock-claim.js";
import WarehouseStockAudit from "./page/warehouse/stock-audit.js";
import WarehousePartsMaster from "./page/warehouse/parts-master.js";
import WarehouseSupplier from "./page/warehouse/supplier.js";
import WarehouseUoms from "./page/warehouse/uoms.js";
import WarehousePartCategories from "./page/warehouse/part-categories.js";
import WarehouseBrands from "./page/warehouse/brands.js";
import WarehouseModels from "./page/warehouse/models.js";
import WarehouseReasons from "./page/warehouse/reasons.js";
import WarehouseBranches from "./page/warehouse/branches.js";
import WarehouseSeries from "./page/warehouse/series.js";
import WarehouseLocation from "./page/warehouse/location.js";
import WarehouseWarehouse from "./page/warehouse/warehouse.js";
import WarehouseSetting from "./page/warehouse/settings.js";
import WarehouseAdjustmentStocks from "./page/warehouse/adjustment-stocks.js";
import WarehouseImportCenter from "./page/warehouse/import-center.js";


import Notfound from "./page/notfound.js";
import Forbidden from "./page/forbidden.js";

const AppRoutes = () => (
  <Routes>
    <Route path="/template" element={<Template />} />

    <Route path="/" element={<Login />} />
    <Route path="/portal" element={<Portal />} />
    <Route path="/console" element={<Console />} />
    <Route path="/policy-privacy" element={<PolicyPrivacy />} />
    {/* หน้า 403 - ต้องอยู่นอก PermissionRoute ไม่งั้นการเด้งมาหน้านี้จะวนลูป */}
    <Route path="/forbidden" element={<Forbidden />} />

    {/* ===== Protected routes (ตรวจ permission ตามเมนูใน global.js) ===== */}
    <Route element={<PermissionRoute />}>

    {/* Mobile */}
    <Route path="/mb/mobile" element={<Mobile />} />

    {/* SUPER USER */}
    <Route path="/su/companies" element={<CompanyManagement />} />

    {/* Admin */}
    <Route path="/ad/asset-report" element={<AdminAssetReport />} />
    <Route path="/ad/assets" element={<AdminAssets />} />
    <Route path="/ad/audit-logs" element={<AdminAuditLogs />} />
    <Route path="/ad/settings" element={<AdminSettings />} />
    <Route path="/ad/cost-report" element={<AdminCostReport />} />
    <Route path="/ad/customers" element={<AdminCustomers />} />
    <Route path="/ad/dashboard" element={<AdminDashboard />} />
    <Route path="/ad/inspection-plan" element={<AdminInspectionPlan />} />
    <Route path="/ad/pm-compliance" element={<AdminPmCompliance />} />
    <Route path="/ad/pm-dashboard" element={<AdminPmDashboard />} />
    <Route path="/ad/checklist-templates" element={<AdminChecklistTemplates />} />
    <Route path="/ad/roles" element={<AdminRoles />} />
    <Route path="/ad/scheduling" element={<AdminScheduling />} />
    <Route path="/ad/sales-visit-planning" element={<AdminSalesVisitPlanning />} />
    <Route path="/ad/objectives" element={<AdminObjectives />} />
    <Route path="/ad/technicians" element={<AdminTechnicians />} />
    <Route path="/ad/sale" element={<AdminSale />} />
    {/* ปิดหน้า finance ไว้ก่อน (ยังไม่ได้ใช้งาน) */}
    {/* <Route path="/ad/finance" element={<AdminFinance />} /> */}
    <Route path="/ad/users" element={<AdminUsers />} />
    <Route path="/ad/departments" element={<AdminDepartments />} />
    <Route path="/ad/sections" element={<AdminSections />} />
    <Route path="/ad/positions" element={<AdminPositions />} />
    <Route path="/ad/projects" element={<AdminProjects />} />
    <Route path="/ad/work-order-summary" element={<AdminWorkOrderSummary />} />
    <Route path="/ad/work-orders" element={<AdminWorkOrders />} />
    <Route path="/ad/work-requests" element={<AdminWorkRequests />} />
    <Route path="/ad/workrequest-config-wireframe" element={<AdminWorkrequestConfigWireframe />} />
    <Route path="/ad/service-bom-config" element={<AdminServiceBomConfig />} />
    <Route path="/ad/customer-warranty-conditions" element={<AdminCustomerWarrantyConditions />} />
    <Route path="/ad/company-vehicles" element={<AdminCompanyVehicles />} />
    <Route path="/ad/root-causes" element={<AdminRootCauses />} />
    <Route path="/ad/company-holidays" element={<AdminCompanyHolidays />} />
    <Route path="/ad/technician-leaves" element={<AdminTechnicianLeaves />} />

    {/* Customer */}
    <Route path="/cs/appointments" element={<CustomerAppointments />} />
    <Route path="/cs/asset-report" element={<CustomerAssetReport />} />
    <Route path="/cs/assets" element={<CustomerAssets />} />
    <Route path="/cs/cost-report" element={<CustomerCostReport />} />
    <Route path="/cs/dashboard" element={<CustomerDashboard />} />
    <Route path="/cs/service-history" element={<CustomerServiceHistory />} />
    <Route path="/cs/service-summary" element={<CustomerServiceSummary />} />
    <Route path="/cs/sla-report" element={<CustomerSlaReport />} />
    <Route path="/cs/work-requests" element={<CustomerWorkRequests />} />

    {/* Warehouse Routes */}
    <Route path="/wh/dashboard" element={<WarehouseDashboard />} />
    {/* ปิดไว้ก่อน: ต้อง comment คู่กับเมนูใน global.js เสมอ
        ถ้าเหลือ route ไว้แต่ลบเมนู PermissionRoute จะมองว่า path นี้ "ไม่ประกาศสิทธิ์" แล้วปล่อยผ่านทุกคน */}
    {/* <Route path="/wh/assets" element={<WarehouseAssets />} /> */}
    <Route path="/wh/stock" element={<WarehouseStock />} />
    <Route path="/wh/technician-stock" element={<WarehouseTechnicianStock />} />
    <Route path="/wh/parts-withdraw" element={<WarehousePartsWithdraw />} />
    <Route path="/wh/parts-return" element={<WarehousePartsReturn />} />
    <Route path="/wh/pr-po" element={<WarehousePrPo />} />
    <Route path="/wh/goods-receipt" element={<WarehouseGoodsReceipt />} />
    <Route path="/wh/goods-issue" element={<WarehouseGoodsIssue />} />
    <Route path="/wh/stock-claim" element={<WarehouseStockClaim />} />
    <Route path="/wh/stock-audit" element={<WarehouseStockAudit />} />
    <Route path="/wh/part-master" element={<WarehousePartsMaster />} />
    <Route path="/wh/supplier" element={<WarehouseSupplier />} />
    <Route path="/wh/uoms" element={<WarehouseUoms />} />
    <Route path="/wh/part-categories" element={<WarehousePartCategories />} />
    <Route path="/wh/brands" element={<WarehouseBrands />} />
    <Route path="/wh/models" element={<WarehouseModels />} />
    <Route path="/wh/reasons" element={<WarehouseReasons />} />
    <Route path="/wh/branches" element={<WarehouseBranches />} />
    <Route path="/wh/series" element={<WarehouseSeries />} />
    <Route path="/wh/location" element={<WarehouseLocation />} />
    <Route path="/wh/warehouse" element={<WarehouseWarehouse />} />
    <Route path="/wh/settings" element={<WarehouseSetting />} />
    <Route path="/wh/adjustment-stocks" element={<WarehouseAdjustmentStocks />} />
    <Route path="/wh/import-center" element={<WarehouseImportCenter />} />

    </Route>
    {/* ===== End protected routes ===== */}

    <Route path="/*" element={<Notfound />} />
  </Routes>
);

export default AppRoutes;
